import axios, { AxiosRequestConfig } from 'axios';
import axiosRetry, { exponentialDelay } from 'axios-retry';

axiosRetry(axios, { retries: 3, retryDelay: exponentialDelay });

export type RequestConfig = AxiosRequestConfig;

export async function get(url: string, config: RequestConfig) {
  return axios.get(url, config);
}

export async function post(url: string, data: any, config: RequestConfig) {
  return axios.post(url, data, config);
}
